import React from 'react';

export default props => {
  return (
    <img
      src="/img/map_plug_logo_transparent.png"
      alt="MapPlug Logo"
      className="responsive"
      {...props}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/Logo/index.jsx